export const nodeTypes = ["paragraph", "bulleted-list", "numbered-list"];
